var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TOP"}},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('div',[_c('nav',{staticClass:"navbar fixed-top",staticStyle:{"padding":"0px","border-top":"0px"}},[_c('top-nav-bar'),_c('nav-bar-dewc')],1)]),_c('div',[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('router-view')],1),_c('page-footer-dewc')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }